import React from 'react';
import { Link } from 'react-router-dom';
import ProfileImage from '../profileImage';

const PostHeader = ({ post, currentUser, onDelete, isDeleting }) => {
  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center space-x-3">
        <Link to={`/feed/${post.user?._id || post.user?.id}`}>
          <ProfileImage
            image={post.user?.profilePicture}
            alt={post.user?.userName}
            className="w-12 h-12 rounded-full object-cover ring-2 ring-blue-100 hover:ring-blue-200 transition-all"
          />
        </Link>
        <div>
          <Link 
            to={`/feed/${post.user?._id || post.user?.id}`}
            className="font-semibold text-lg text-gray-900 hover:text-blue-600 transition-colors"
          >
            {post.user?.firstName} {post.user?.lastName}
          </Link>
          <Link 
            to={`/feed/${post.user?._id || post.user?.id}`}
            className="text-sm text-gray-500 hover:text-blue-500 transition-colors"
          >
            @{post.user?.userName}
          </Link>
          <div className="text-xs text-gray-400">{post.timeAgo}</div>
        </div>
      </div>
      
      {/* Delete Button - Only show for current user's posts */}
      {(() => {
        const currentUserId = currentUser?._id || currentUser?.id;
        const postUserId = post.user?._id || post.user?.id;
        return currentUserId === postUserId;
      })() && (
        <button
          onClick={() => onDelete(post.postId || post._id || post.id)}
          disabled={isDeleting}
          className="p-2 text-gray-400 hover:text-red-500 transition-colors disabled:opacity-50"
          title="Delete post"
        >
          {isDeleting ? (
            <div className="animate-spin rounded-full h-5 w-5 border-2 border-red-500 border-t-transparent"></div>
          ) : (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" 
              />
            </svg>
          )}
        </button>
      )}
    </div>
  );
};

export default PostHeader; 